import { Component, ViewChild } from '@angular/core';
import { NotificationPopupComponent } from '../Components/notification-popup/notification-popup.component';
import { Branch, Lookups, PopupButton, PopupModel, PopupModelReturn, ReportHistory, Staff } from '../../AllTableClasses';
import { Router } from '@angular/router';
import { PopupNotificationService } from '../../Services/popup-notification.service';
import { LookupsService } from '../../Services/lookups.service';
import { StaffService } from '../../Services/staff.service';
import { ReportsService } from '../../Services/reports.service';
import { SchedulerService } from '../../Services/scheduler.service';
import { LoadingService } from '../../Services/loading.service';

@Component({
  selector: 'app-reports-main-page',
  templateUrl: './reports-main-page.component.html',
  styleUrl: './reports-main-page.component.scss'
})
export class ReportsMainPageComponent {
  public filterString!: string;

  @ViewChild('popup') popup!: NotificationPopupComponent;

  public staffList: Array<Staff> = new Array<Staff>();

  //public selectedStaff: Staff = new Staff();
  public selectedStaffID?: number;
  public staffName!: string;
  public selectedBranch!: string;
  public StartDate!: string;
  public EndDate!: string;

  public reportHistory: Array<ReportHistory> = new Array<ReportHistory>();
  public provinces: Array<Lookups> = new Array<Lookups>();
  public branches: Array<Branch> = new Array<Branch>();
  public selectedProvinceID!: number;
  public selectedBranchID?: number | null;

  constructor(
    private router: Router,
    private popupNotificationService: PopupNotificationService,
    //private membersService: MembersService,
    private schedulerService: SchedulerService,
    private staffService: StaffService,
    private lookupService: LookupsService,
    private reportService: ReportsService,
    private loadingService: LoadingService
  ) { }

  ngOnInit(): void {
    this.ActivityHistoryGetByReport();
    this.StaffGet();
    this.ProvinceGet();
  }

  public ProvinceGet() {
    this.lookupService.ProvinceGet((data) => {
      if (data.Success) {
        this.provinces = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public ActivityHistoryGetByReport() {
    this.reportService.ActivityHistoryGetByReport((data) => {
      if (data.Success) {
        this.reportHistory = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }


  public BranchGetByProvinceID() {
    this.branches = [];
    this.selectedBranchID = null;
    this.schedulerService.BranchGetByProvinceID(this.selectedProvinceID, (data) => {
      if (data.Success) {
        this.branches = JSON.parse(data.Data);
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });

  }

  public StaffGet() {
    //this.selectedStaff = new Staff();

    this.staffService.StaffGet('', false, (data) => {
      if (data.Success) {
        this.staffList = data.Data;
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  onGenerateReport(report: ReportHistory, rendertype: string) {
    if (!this.StartDate || !this.EndDate) {
      const errorMessage = "Please ensure Date To and Date From fields are filled in.";
      this.showNotifcationPopup(false, errorMessage);
      return;
    }

    const startDate = new Date(this.StartDate);
    const endDate = new Date(this.EndDate);

    if (endDate <= startDate) {
      const errorMessage = "The End Date must be after the Start Date.";
      this.showNotifcationPopup(false, errorMessage);
      return;
    }

    if (!this.selectedBranchID) {
      this.selectedBranchID = 0;
    }
    if (!this.selectedStaffID) {
      this.selectedStaffID = 0;
    }

    const reportPath = report.FilePath;
    const reportName = report.FileName;

    const parameters = {
      BranchID: this.selectedBranchID,
      AudiologistID: this.selectedStaffID,
      DateFrom: this.StartDate,
      DateTo: this.EndDate
    }; // Add any required parameters here

    this.loadingService.show();

    this.reportService.GenerateReport(reportPath, reportName, parameters, rendertype, (data) => {
      this.loadingService.hide();
      if (data instanceof Blob) {
        if (rendertype == 'PDF') {
          const blob = new Blob([data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${reportName}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        } else {
          const blob = new Blob([data], { type: "application/vnd.ms-excel" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${reportName}.xls`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }

        report.Action = 'Report Downloaded';
        this.ReportActivityHistorySet(report);

      } else if (data.Success === false) {
        // If there's an error, display the error message
        this.loadingService.hide();
        this.showNotifcationPopup(data.Success, data.UserErrorMessage);
      }
    }, (error) => { });
  }

  public ReportActivityHistorySet(report: ReportHistory) {
    this.reportService.ReportActivityHistorySet(report, (data) => {
      if (data.Success) {
        this.ActivityHistoryGetByReport();
      }
      else {
        this.showNotifcationPopup(data.Success, data.UserErrorMessage);

      }
    }, (error) => { });
  }

  public showNotifcationPopup(success: boolean, message?: string) {
    let notificationPopup: PopupModel = new PopupModel();

    if (success == true)
    {
    }
    else {
      notificationPopup.Message = message;
      notificationPopup.MessageType = 'error';
      this.popupNotificationService.ShowPopup(notificationPopup).then((res: PopupModelReturn) => { });
    }

  }
}
